/**
 * How the investor asked for a transaction - the "Request type" every
 * transaction table shows (requested 15 Oct 2026): the side they FIXED, which
 * the Core never changes, while the other side is worked out at the price.
 *
 * Read from the order's `basis` ('AMOUNT', 'UNITS' or 'DERIVED') and
 * `isFullHolding`, which an order (GET /orders) and a register transaction
 * (GET register/transactions, from its order) both carry:
 *
 *   AMOUNT         'LKR based'      the LKR is fixed; the units follow the price
 *   UNITS          'Unit based'     the units are fixed; the LKR follows the price
 *   full holding   'Full holding'   every unit the holder has; the LKR follows the price
 *   DERIVED        'From switch'    a switch-in: its LKR is what its switch-out releases
 *   no order       null             an upload or a conversion: not a request at all
 */
const LABEL = Object.freeze({ AMOUNT: 'LKR based', UNITS: 'Unit based', DERIVED: 'From switch' });

/**
 * @param {{ basis?: string|null, isFullHolding?: boolean, orderType?: string|null }} row
 * @returns {string|null}
 */
export function requestType(row) {
    // A transfer moves units at cost: always a unit count, never an LKR request.
    if (row?.orderType === 'TRF_OUT' || row?.orderType === 'TRF_IN') return 'Unit based';
    if (row?.isFullHolding) return 'Full holding';
    return LABEL[row?.basis] ?? null;
}
